import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      alert: false,
      isUpdate: false,
      tab: 0,
      cv: 0,
      id: null,
      formulir: {},
      autosave: null,
    };
  },
  computed: {
    ...mapState('preferensi', {
      ptk: (state) => state.data?.ptk ?? {},
      instruktur: (state) => state.data?.instruktur ?? {},
      peserta: (state) => state.data?.peserta ?? {},
      config: (state) => state.data?.config ?? {},
      peserta_status: (state) => state.data?.peserta_status ?? {},
      instruktur_status: (state) => state.data?.instruktur_status ?? {},
    }),

    ...mapState('auth', {
      env: (state) => state.env ?? 'local',
    }),

    ...mapState('esai', {
      detailEsai: (state) => state.detail ?? [],
      meta: (state) => state.meta ?? [],
    }),

    gelombang() {
      return this.$getDeepObj(this.config, `${this.isKasek ? 'peserta' : 'pelatih_ahli'}.gelombang`);
    },

    wktTutup() {
      return this.$getDeepObj(
        this.config,
        `${this.isKasek ? 'peserta' : 'pelatih_ahli'}.registrasi.${this.gelombang || 1}.wkt_selesai`
      );
    },

    profilID() {
      const id = this.peserta?.psp_profil_id ?? this.instruktur?.psp_profil_id;
      return id;
    },

    statusLengkap() {
      return this.meta?.status_lengkap ?? {};
    },

    isValidEsai() {
      let esais = {};
      for (const i of this.items) {
        const esai = (this.detailEsai || []).filter((item) => {
          return Number(item.k_profil_esai_psp) === Number(i.id);
        });

        esais[i.id] =
          String(this.$getDeepObj(esai, '0.deskripsi') || '')
            ?.trim()
            ?.split(' ').length >= i.min_kata &&
          String(this.$getDeepObj(esai, '0.deskripsi') || '')
            ?.trim()
            ?.split(' ').length <= i.maks_kata;
      }

      return esais;
    },

    isKasek() {
      return !!Object.keys(this.peserta).length;
    },

    isAjuan() {
      const kVerval = this.isKasek ? this.peserta?.k_verval_psp : this.instruktur?.k_verval_psp;
      return kVerval > 1;
    },

    isTutupAjuan() {
      return false;
    },

    tutupPendaftaran() {
      return this.isKasek ? this.peserta_status.tutup || '' : this.instruktur_status.tutup || '';
    },
  },
  created() {
    this.onReload();
  },
  methods: {
    ...mapActions('preferensi', ['getPreferensi']),

    ...mapActions('esai', ['fetch', 'detail', 'getPertanyaan', 'saveEsai']),

    getData() {
      let esai = {};

      for (const e of this.detailEsai) {
        esai[e.k_profil_esai_psp] = this.getTempEsai(e.k_profil_esai_psp) || e.deskripsi || '';
      }

      return esai;
    },

    getEsai(kEsai) {
      const esai = (this.detailEsai || []).filter((item) => {
        return Number(item.k_profil_esai_psp) === Number(kEsai);
      });

      return esai[0] || {};
    },

    onEdit(payload) {
      if (this.tutupPendaftaran) {
        const msg = `<p class="title mb-2">Mohon maaf! ${this.tutupPendaftaran}`;
        this.$info(msg, `Perubahan data tidak diperbolehkan`, {
          tipe: 'warning',
          data: '',
        });
        return;
      }

      if (this.isAjuan) {
        const msg = `<p class="title mb-2">Mohon maaf! Data Anda telah diajukan dan dalam Proses verval, 
                    sehingga tidak dapat diubah untuk saat ini</p> 
                    Jika Anda ingin mengubah Data Anda, silakan melakukan aksi batal ajuan`;
        this.$warning(msg, `Ubah Data`);
        return;
      }

      let isValid = true;
      let kategori = 0;
      for (let i = 1; i <= this.tab; i++) {
        if (isValid) {
          isValid = !this.isInvalidKategori(i, true);
        }
        if (!isValid) {
          kategori = i;
          break;
        }
      }
      if (!isValid && this.isSebagianKategori(this.tab)) {
        this.$info(`Silakan lengkapi esai pada kategori ${kategori} yang belum memenuhi prasyarat`, {
          tipe: 'warning',
          data: '',
        });
        return;
      }

      // mapping pertanyaan GP
      const items = this.items.filter((item) => {
        return item.nomor === this.tab + 1;
      });

      this.isUpdate = true;
      const header =
        this.env !== 'demo'
          ? this.expansion[this.tab] && this.expansion[this.tab]['title']
          : `${this.tab + 1}. Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`;

      this.$set(this.formulir, 'title', `Lengkapi Esai`);
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'mode', 'insert');
      this.$set(this.formulir, 'items', items);
      this.$set(this.formulir, 'header', header);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', this.getData(payload.type));
        clearInterval(this.autosave);
        this.onSetAutoSave();
      });
    },

    onSetAutoSave() {
      this.autosave = setInterval(() => {
        this.save(true);
      }, 3 * 60 * 1000);
    },

    onSave() {
      this.save();
    },

    onReload() {
      this.fetch({ id: this.profilID, reset: true });
      const currTab = Object.keys(this.statusLengkap).filter((item) => !this.statusLengkap[item])[0] || 0;
      this.tab = currTab - 1;
    },

    save(isAutosave = false) {
      const formulir = (this.$refs?.formulir && this.$refs?.formulir?.form) || {};
      let status = [];
      let params = [];

      for (const key in formulir) {
        // add status jml kata esai
        const obj = this.items.find((s) => Number(s.id) === Number(key));
        const jmlKata = this.$wordCount(formulir[key]);
        status.push(jmlKata >= obj?.min_kata && jmlKata <= obj.maks_kata);

        // simpan ke param
        if (formulir[key]) {
          params.push({
            k_profil_esai_psp: key,
            deskripsi: this.$refs.formulir.form[key],
          });
        }
      }

      // auto save tanpa loading
      if (this.$refs?.modal) this.$refs.modal.loading = !isAutosave;
      this.$store.commit('SET_AUTOSAVE', isAutosave);

      if (!isAutosave && !status.includes(false)) {
        const message = `<h3>Apakah Anda yakin akan mengirim jawaban esai di nomor ini?</h3>
                        Setelah menekan tombol <b>KIRIM</b> maka jawaban Anda di soal esai ini akan terkirim dan 
                        <b>TIDAK AKAN BISA DIREVISI/DIKOREKSI KEMBALI</b>.`;
        this.$confirm(message, `Kirim Esai`, {
          tipe: 'warning',
          lblConfirmButton: 'Kirim',
          useReject: true,
        })
          .then(() => {
            this.saving(isAutosave, status, params);
          })
          .catch(() => {
            if (this.$refs.modal) this.$refs.modal.loading = false;
          });
      } else {
        this.saving(isAutosave, status, params);
      }
    },

    saving(isAutosave, status, params) {
      this.saveEsai({
        id: this.profilID,
        params: { esais: params, is_autosave: isAutosave },
      })
        .then(() => {
          if (!isAutosave) {
            this[!status.includes(false) ? '$success' : '$warning'](
              !status.includes(false) ? 'Data Esai Berhasil disimpan' : 'Harap melengkapi data esai'
            );
            this.$store.commit('SET_AUTOSAVE', false);
            clearInterval(this.autosave);
            this.onReload();
            this.clearTempEsai();
            this.$refs.modal.dialog = false;
          } else {
            this.$store.commit('SET_AUTOSAVE', false);
          }
        })
        .catch(() => {
          this.$store.commit('SET_AUTOSAVE', false);
          if (this.$refs?.modal) this.$refs.modal.loading = false;
        });
    },

    onCloseModal() {
      if (this.isTempNotSave()) {
        const msg = [
          '<div class="black--text">',
          '<h3 class="subtitle-1">Sistem mendeteksi adanya <strong class="warning--text">Data Esai yang belum tersimpan</strong></h3>',
          '<h3 class="subtitle-1 font-weight-bold" style="font-size: 15px">Tetap keluar dari Form Esai?</h3>',
          '</div>',
        ].join('');
        this.$confirm(msg, 'Peringatan', {
          invert: true,
          tipe: 'error',
          lblConfirmColor: 'grey',
          lblCancelColor: 'red',
        }).then(() => {
          clearInterval(this.autosave);
          this.clearTempEsai();
          if (this.$refs?.modal) this.$refs.modal.dialog = false;
        });
        return;
      }

      clearInterval(this.autosave);
      this.clearTempEsai();
      if (this.$refs?.modal) this.$refs.modal.dialog = false;
    },

    isInvalidKategori(id, all) {
      if (id === 0 && !all) return false;
      return !((this.statusLengkap && this.statusLengkap[id + 1 - 1]) || false);
    },

    isSebagianKategori(id, all) {
      if (id === 0 && !all) return false;
      const pertanyaan = this.items.filter((item) => item.nomor === id + 1);

      return (
        (pertanyaan || []).filter((tanya) => {
          const esai = (this.detailEsai || []).filter((item) => {
            return Number(item.k_profil_esai_psp) === tanya.id;
          });
          return !this.$getDeepObj(esai, '0.deskripsi') || '';
        }).length > 0
      );
    },

    onMutate() {
      this.saveTempEsai();
    },

    saveTempEsai() {
      for (const key in this.$refs.formulir.form) {
        window.localStorage.setItem(key, this.$refs.formulir.form[key]);
      }
    },

    getTempEsai(key) {
      return window.localStorage.getItem(key);
    },

    clearTempEsai() {
      for (const key in this.$refs.formulir.form) {
        window.localStorage.removeItem(key);
      }
    },

    isTempNotSave() {
      return (
        Object.keys(this.$refs.formulir.form || {}).filter((key) => {
          const esai = this.getEsai(key) || {};
          return (esai?.deskripsi ?? '') !== this.getTempEsai(key);
        }).length > 0
      );
    },
  },
};
